import { Controller } from "@hotwired/stimulus"
import { isElementOverflowing } from "../utils"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.measure())
    this.resizeObserver.observe(this.contentTarget)
    this.measure()
  }

  disconnect() {
    this.resizeObserver.disconnect()
  }

  measure() {
    this.contentTarget.classList.remove("limited-height--overflowing")
    this.contentTarget.classList.toggle("limited-height--overflowing", isElementOverflowing(this.contentTarget))
  }
}
